import type {ReactElement} from 'react';
import type {AnimationTrimRangeSliderProps} from './animation-trim-range-slider.types';
import styles from './animation-trim-range-slider.module.scss';
import {RangeSlider} from '@Components/range-slider';

const DEFAULT_STEP = 0.05;

export function AnimationTrimRangeSlider({min, max, value, minGap, onChange, onChangeComplete}: AnimationTrimRangeSliderProps): ReactElement {
  const handleChange = (raw: number | number[]): void => {
    if (Array.isArray(raw) && raw.length === 2) {
      onChange([raw[0], raw[1]]);
    }
  };

  const handleChangeComplete = (raw: number | number[]): void => {
    if (onChangeComplete && Array.isArray(raw) && raw.length === 2) {
      onChangeComplete([raw[0], raw[1]]);
    }
  };

  return (
    <div className={styles.container}>
      <RangeSlider
        className={styles.slider}
        min={min}
        max={max}
        value={value}
        step={DEFAULT_STEP}
        pushable={minGap}
        allowCross={false}
        onChange={handleChange}
        onChangeComplete={handleChangeComplete}
      />
    </div>
  );
}
